<template>
    <div class="p-3">
        <b-modal id="modal-explain-detail" hide-header hide-footer size="lg">
            <explain-detail></explain-detail>
        </b-modal>
        <div id="pop-up" v-if="loading == true">
            <div class="">
                <b-spinner
                    variant="primary"
                    style="width: 4rem; height: 4rem"
                    label=""
                ></b-spinner>
            </div>
        </div>
        <div class="createQuestion">
            <h5>{{ $t("question_list.label.table_title") }}</h5>
            <div class="">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                        <p class="pr-2 text-nowrap">
                            {{ $t("question_list.label.category") }}:
                        </p>
                        <multiselect
                            v-model="cateSelected"
                            :close-on-select="true"
                            :clear-on-select="false"
                            label="category"
                            :multiple="true"
                            :options="categories"
                            :placeholder="$t('question_list.label.placeholder_category')"
                            track-by="category"
                            :hide-selected="true"
                            :max-height="150"
                            class="test"
                            disabled
                        >
                        </multiselect>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center my-4 px-3">
                            <p class="pr-2">{{ $t("question_list.label.type") }}:</p>
                            <select
                                class="createQuestion-dropdown"
                                @change="typeOfQuestion"
                                v-model="form.type"
                                disabled
                            >
                                <option
                                    v-for="tOfQ in typeOfQuestions"
                                    :key="tOfQ.id"
                                    :value="tOfQ.value"
                                >
                                    {{ tOfQ.text }}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex align-items-center my-4 px-3">
                            <p class="pr-2">{{ $t("question_list.label.difficulty") }}:</p>
                            <select
                                class="createQuestion-dropdown"
                                v-model="editQuestion.data.difficulty"
                                disabled
                            >
                                <option
                                    v-for="tOfD in difficulty"
                                    :key="tOfD.id"
                                    :value="tOfD.difficulty"
                                    style="color:black"
                                >
                                    {{ tOfD.difficulty }}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex align-items-center my-4 px-3">
                            <p class="pr-2">{{ $t("question_list.label.score") }}:</p>
                            <input
                                v-model="editQuestion.data.score"
                                type="number"
                                placeholder="0"
                                class="createQuestion-dropdown p-3"
                                style="width: 70px; color:true"
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div class="row justify-content-around">
                    <div class="col left-embed p-0">
                        <!-- //embed video/image -->
                        <div
                            class="d-flex flex-column align-items-center embed-image-video"
                        >
                            <div id="preview" class="">
                                <img
                                    v-if="
                    !editQuestion.data.image_path &&
                      !editQuestion.data.video_path &&
                      !editQuestion.data.embed_image_video
                  "
                                    src="../../assets/images/404.jpg"
                                />
                                <img
                                    v-if="editQuestion.data.image_path"
                                    :src="editQuestion.data.image_s3"
                                    alt=""
                                />
                                <video
                                    style="width:100%; height:100%;"
                                    v-if="editQuestion.data.video_path"
                                    :src="editQuestion.data.video_s3"
                                    id="video-container"
                                    controls
                                ></video>
                                <div
                                    v-if="editQuestion.data.embed_image_video"
                                    id="embedUpload"
                                >
                                    <embed
                                        width="500"
                                        height="250"
                                        :src="editQuestion.data.embed_image_video"
                                        frameborder="0"
                                        style="object-fit: contain"
                                        allowfullscreen
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div
                            v-if="titleTopic"
                            class="title-topic__textArena w-100"
                            style="margin:0px 0px 5px 0px"
                        >
                            <ckeditor
                                :config="editorConfig"
                                :editor="editor"
                                @ready="onReady"
                                v-model="titleTopic" disabled rows="1" maxlength="1500">
                            </ckeditor>
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                            <audio
                                :src="editQuestion.data.audio_s3"
                                id="audio-preview"
                                controls
                                v-if="editQuestion.data.audio_path"
                            />
                            <div
                                id="audio_embed_view"
                                v-html="editQuestion.data.embed_audio"
                                v-if="!editQuestion.data.audio_path"
                                style="width: 100%"
                            >
                                {{ editQuestion.data.embed_audio }}
                            </div>
                        </div>
                        <div class="question-input__textArena mt-1">
                            <ckeditor
                                :config="editorConfig"
                                :editor="editor"
                                @ready="onReady"
                                style="color: black"
                                v-model="editQuestion.data.title"
                                @keyup="charCount()"
                                name=""
                                id=""
                                class=""
                                rows="3"
                                maxlength="1500"
                                disabled
                                :placeholder="$t('question_list.label.placeholder_title')"
                            ></ckeditor>
                            <!-- <span>{{ totalCharacter }} / 1500</span> -->
                        </div>
                        <div
                            class="w-100 justify-content-between d-flex align-items-center"
                        >
                            <button v-b-modal.modal-explain-detail class="btn-explanation">
                                {{ $t("question_list.label.explanation") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <h5 v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'" class="pt-2">
                {{ $t("question_list.label.answer") }}
            </h5>
            <div
                v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'"
                class="formCreateQuestion"
            >
                <div
                    v-for="(item, index) in editQuestion.data.answer"
                    :key="index"
                    class="answerQuestion m-1"
                >
                    <p>{{ item.ans_id }}.</p>
                    <div
                        v-if="
              !item.image &&
                !answerUpload[index] &&
                editQuestion.data.isText == false
            "
                        :key="imageReRender"
                        class="d-flex align-items-center justify-content-center h-100"
                    ></div>
                    <div
                        v-if="editQuestion.data.isText == true"
                        :key="imageReRender"
                        class=""
                    >
                        <ckeditor
                            :config="editorConfig"
                            :editor="editor"
                            @ready="onReady"
                            v-model="editQuestion.data.answer[index].ans_value"
                            @keyup="
                charCount(editQuestion.data.answer[index].ans_value, index)
              "
                            name=""
                            disabled
                            id=""
                            rows="3"
                            maxlength="1500"
                            :placeholder="$t('question_list.label.placeholder_answer')"
                            class="answer-input__text disable-textarena mt-2"
                        ></ckeditor>
                    </div>
                    <div
                        style=""
                        v-if="
              (item.image || answerUpload[index]) &&
                editQuestion.data.isText == false
            "
                        class=""
                        :id="'preview' + index"
                        :key="imageReRender"
                    >
                        <img v-if="item.image" :src="item.image_answer_s3" />
                        <img v-if="answerUpload[index]" :src="answerUpload[index]" />
                    </div>
                    <!-- Choose Input -->
                    <div class="text-answer">
                        <p class="checkboxInvisible checkboxInvisible__detail">
                            <ion-icon
                                v-if="item.isCorrect == true"
                                name="checkmark-circle"
                                style="color: #37ABE5;"
                            ></ion-icon>
                            <ion-icon v-else name="ellipse-outline"></ion-icon>
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-3 float-right">
                <b-button @click="hideModal" style="margin-left: 1rem" variant="primary"
                >{{ $t("question_list.label.close") }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import ExplainDetail from "./QuestionExplainDetailModal.vue";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
    props: {
        titleTopic: Text
    },
    components: {
        Multiselect,
        ExplainDetail
    },
    data() {
        return {
            editor: DecoupledEditor,
            editorConfig: {
                toolbar: [ 'bold', 'italic','underline'],
                placeholder: this.$t('question_list.label.placeholder_title')
            },
            editorConfigAnswer: {
                toolbar: ['bold', 'italic', 'underline'],
                placeholder: this.$t("question_list.label.placeholder_answer")
            },
            loading: true,
            imageReRender: 10,
            isTrueSet: [],
            cateSelected: [],
            categories: [],
            isText: null,
            typeOfQuestions: [
                { text: "Listening", value: 0 },
                { text: "Writing", value: 1 },
                { text: "Reading", value: 2 },
                { text: "Speaking", value: 3 }
            ],
            alphabetAnswerSelected: "",
            typeOfAnswers: [
                { text: "Alphabet", value: 0 },
                { text: "Number", value: 1 }
            ],
            typeOfAnswer: "",
            statusOfQuestions: [
                { text: "Active", value: 0 },
                { text: "Inactive", value: 1 }
            ],
            answerOptionOfQuestions: [
                { text: "One choice", value: 0 },
                { text: "Multiple choice", value: 1 }
            ],
            totalCharacter: 0,
            answerUpload: [],
            correctAnswer: [],
            file: "",
            filterData: {
                search: "",
                page: 1,
                selected: {
                    category: null,
                    typeQuestion: null,
                    typeOfQuestion: null,
                    difficulty: null,
                    score_from: null,
                    score_to: null
                }
            },
            valueTypeOfAnswer: "",
            optionValueTypeOfAnswer: [
                { text: "Select", value: "A" },
                { text: "Text", value: "B" },
                { text: "Images", value: "C" }
            ],
            valueTypeOfAnswers: [
                ["A", "B", "C", "D", "E", "F"],
                [1, 2, 3, 4, 5, 6]
            ],
            valueAnswerOption: "",
            form: {
                title: "",
                type: "",
                status: "",
                score: "",
                difficulty: "",
                category: [],
                explain: "explain",
                image_path: "",
                video_path: "",
                embed_image_video: "",
                audio_path: "",
                embed_audio: "",
                answer_option: "One choice",
                answer: [],
                image: [],
                answer_text: [],
                number_answer: 2,
                id_ans_update: []
            }
        };
    },
    computed: {
        ...mapState("config", ["category", "difficulty"]),
        ...mapState("question", ["editQuestion", "explain", "explain_path"])
    },
    methods: {
        onReady(editor) {
            editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        // lay dap an dung
        getMultiCorrectAnswer(index) {
            const answer = this.form.answer[index];
            if (answer.isCorrect === true) {
                answer.isCorrect = false;
            } else {
                answer.isCorrect = true;
            }
        },

        getCorrectAnswer(index) {
            this.form.answer = [];
            for (let i = 0; i < this.form.number_answer; i++) {
                const reqData = { ans_id: i + 1, isCorrect: false };
                this.form.answer.push(reqData);
            }
            this.form.answer[index]["ans_id"] = index + 1;
            this.form.answer[index]["isCorrect"] = true;
        },

        // so luong cau tra loi
        numberAnswerOfQuestion(e) {
            if (e.target.options.selectedIndex > -1) {
                let numberOfAnswerSelect = parseInt(
                    e.target.options[e.target.options.selectedIndex].outerText
                );
                let numberOfAnswerRender = parseInt(
                    this.editQuestion.data.answer.length
                );

                this.form.number_answer = numberOfAnswerSelect;

                // neu so luong dap an hien tai < dap an dc chon
                if (numberOfAnswerRender < numberOfAnswerSelect) {
                    for (
                        numberOfAnswerRender;
                        numberOfAnswerRender < numberOfAnswerSelect;
                        numberOfAnswerRender++
                    ) {
                        const reqData = {
                            ans_id: numberOfAnswerRender + 1,
                            ans_value: null,
                            image: null,
                            isCorrect: false
                        };
                        this.editQuestion.data.answer.push(reqData);
                    }
                }
                // neu so luong dap an hien tai > dap an dc chon
                if (numberOfAnswerRender > numberOfAnswerSelect) {
                    for (
                        numberOfAnswerRender;
                        numberOfAnswerRender > numberOfAnswerSelect;
                        numberOfAnswerRender--
                    ) {
                        this.editQuestion.data.answer.pop();
                    }
                }

                // tao form dap an
                this.form.answer = [];
                // neu dap an hien tai > dap an duoc chon
                if (numberOfAnswerRender > numberOfAnswerSelect) {
                    for (let i = 0; i < numberOfAnswerSelect; i++) {
                        const reqData = {
                            ans_id: i + 1,
                            isCorrect: this.editQuestion.data.answer[i].isCorrect
                        };
                        this.form.answer.push(reqData);
                    }
                } else {
                    // neu dap an hien tai < dap an duoc chon
                    for (let i = 0; i < numberOfAnswerSelect; i++) {
                        if (i < numberOfAnswerRender) {
                            const reqData = {
                                ans_id: i + 1,
                                isCorrect: this.editQuestion.data.answer[i].isCorrect
                            };
                            this.form.answer.push(reqData);
                        } else {
                            const reqData = { ans_id: i + 1, isCorrect: false };
                            this.form.answer.push(reqData);
                        }
                    }
                }

                // set alphabet <-> number
                for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
                    this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
                        this.typeOfAnswer
                        ][i];
                }
            }
        },
        // the loai cau hoi
        typeOfQuestion(e) {
            if (e.target.options.selectedIndex > -1) {
                this.form.type = parseInt(e.target.options.selectedIndex);
                this.editQuestion.data.type =
                    e.target.options[e.target.options.selectedIndex].outerText;
            }
        },
        // alphabet cau hoi
        alphabetOfQuestion(e) {
            let valueSelected = e.target.options.selectedIndex;
            if (e.target.options.selectedIndex > -1) {
                this.alphabetAnswerSelected = parseInt(
                    e.target.options[valueSelected].outerText
                );
            }
            for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
                this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
                    valueSelected
                    ][i];
            }
            this.imageReRender++;
        },
        // trang thai cau hoi
        statusOfQuestion(e) {
            if (e.target.options.selectedIndex > -1) {
                this.editQuestion.data.status = e.target.options.selectedIndex;
            }
        },
        // do kho cau hoi
        difficultyOfQuestion(e) {
            if (e.target.options.selectedIndex > -1) {
                this.editQuestion.data.difficulty =
                    e.target.options[e.target.options.selectedIndex].outerText;
            }
        },
        // so luong cau tra loi chinh xac
        manyAnswerOfQuestion(e) {
            let answerOptionSelected = e.target.options.selectedIndex;
            if (e.target.options.selectedIndex > -1) {
                this.valueAnswerOption = answerOptionSelected;
            }
            if (answerOptionSelected == 1) {
                this.editQuestion.data.answer_option = "Multiple choice";
            }
            if (answerOptionSelected == 0) {
                this.editQuestion.data.answer_option = "One choice";
            }
        },
        // the loai dap an
        answerTypeOfQuestion(e) {
            let selected = "";
            if (e.target.options.selectedIndex > -1) {
                selected = e.target.options.selectedIndex;
            }
            if (selected == 1) {
                this.isText = true;
                this.editQuestion.data.isText = true;
            }
            if (selected == 2) {
                this.isText = false;
                this.editQuestion.data.isText = false;
            }
            this.imageReRender++;
        },
        charCount: function(e, i) {
            this.form.answer_text[i] = e;

            if (!this.form.id_ans_update.includes(i)) {
                this.form.id_ans_update.push(i);
            }
        },
        hideModal() {
            this.$bvModal.hide("modal-detail");
        },
        renderQuestion() {
            this.loading = true;
            this.categories = this.category;
            var editQuestions = this.editQuestion.data;

            for (let i = 0; i < editQuestions.category.length; i++) {
                const reqData = { category: editQuestions.category[i] };
                this.cateSelected.push(reqData);
            }
            if (editQuestions.type == "Listening") {
                this.form.type = 0;
            } else if (editQuestions.type == "Writing") {
                this.form.type = 1;
            } else if (editQuestions.type == "Reading") {
                this.form.type = 2;
            } else if (editQuestions.type == "Speaking") {
                this.form.type = 3;
            }
            this.form.embed_audio = editQuestions.embed_audio;
            this.form.image_path = editQuestions.image_s3;
            this.form.audio_path = editQuestions.audio_s3;
            this.totalCharacter = editQuestions.title.length;
            this.isText = editQuestions.isText == 1 ? "true" : "false";
            this.valueTypeOfAnswer = editQuestions.isText == 1 ? "B" : "C";
            if (editQuestions.type !== "Writing" && editQuestions.type !== "Speaking") {
                this.typeOfAnswer =
                    editQuestions.answer[0].ans_id == 1 ? 1 : 0;
            }
            this.valueAnswerOption =
                editQuestions.answer_option == "One choice" ? 0 : 1;
            this.form.status = editQuestions.status == 0 ? 0 : 1;
        }
    },
    async created() {
        await this.$root.$loading.start();
        this.loading = true;
        await this.renderQuestion();
        this.loading = false;
        this.$root.$loading.finish();
    }
};
</script>

<style>
@import "../../assets/scss/Questions.scss";
.test .multiselect__tag-icon {
    display: none;
}
.test .multiselect__select {
    display: none;
}
.checkboxInvisible__detail {
    width: unset;
    height: unset;
}
.checkboxInvisible__detail ion-icon {
    font-size: 30px;
}
.disable-textarena {
    color: black;
    background-color: white;
}
.title-topic__textArena .ck.ck-toolbar.ck-rounded-corners{
    display: none;
}
</style>
